const DOCUMENT = 'SUB_UNIT_PRICE_LIST_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_ERROR: DOCUMENT + 'LOAD_ERROR',
  DOWNLOAD_CSV: DOCUMENT + 'DOWNLOAD_CSV',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadDataError: data => ({
    type: actions.LOAD_ERROR,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  downloadCSV: data => ({
    type: actions.DOWNLOAD_CSV,
    payload: data,
  }),
};

export default actions;
